import {
    enableAddToCartButton,
    disableAddToCartButton
} from '../variant-helper/addToCartButton';
import AddToCartForm
    from '../../../../../../../ProductDetailPage/Theme/default/components/molecules/add-to-cart-form/add-to-cart-form';

const validateGiftCardInput = (giftCardValue: string, minGiftCardValue: number, maxGiftCardValue: number): boolean => {
    const giftCardInputValue = giftCardValue.trim();
    const pattern = /^\d+$/;
    const isInteger = pattern.test(giftCardInputValue);
    return isInteger
        ? parseInt(giftCardInputValue, 10) >= minGiftCardValue && parseInt(giftCardInputValue, 10) <= maxGiftCardValue
        : false;
};

const getGiftCardAppropriateId = (multipliedValue: number, giftCardInput: HTMLInputElement): string | undefined => {
    const dataOptions: string | null = giftCardInput.getAttribute('data-options');
    try {
        const giftCardoptions: Record<string, any> = JSON.parse(dataOptions);
        const giftCardOptionResult = Object.values(giftCardoptions).find((giftOption) => giftOption.price === multipliedValue);
        return giftCardOptionResult ? giftCardOptionResult.id : undefined;
    } catch (error) {
        return undefined;
    }
};

export const enableGiftCardProductOption = (addToCartFormElement: HTMLFormElement, giftCardInput: HTMLInputElement): void => {
    disableAddToCartButton(addToCartFormElement);
    giftCardInput.addEventListener('input', () => {
        const giftCardValue: string = giftCardInput.value;

        // Remove non-numeric characters
        const sanitizedValue = giftCardValue.replace(/[^0-9]/g, '');
        // Update the input field with the sanitized value
        giftCardInput.value = sanitizedValue;

        const minGiftCardValue: number = parseFloat(giftCardInput.min);
        const maxGiftCardValue: number = parseFloat(giftCardInput.max);

        const isValidInput: boolean = validateGiftCardInput(giftCardValue, minGiftCardValue, maxGiftCardValue);

        if (isValidInput) {
            const multipliedValue = parseInt(giftCardValue, 10) * 100;
            const appropriateId = getGiftCardAppropriateId(multipliedValue, giftCardInput);

            appropriateId
                ? (enableAddToCartButton(addToCartFormElement), addToCartFormElement.dataset[AddToCartForm.DATA_PRODUCT_OPTION] = appropriateId)
                : disableAddToCartButton(addToCartFormElement);
        } else {
            disableAddToCartButton(addToCartFormElement);
        }
    });
};